import React, { Component, Fragment } from "react";
import { Map as LeafletMap, TileLayer } from "react-leaflet";
import Lightbox from "react-images";
import map from "lodash.map";
import isEmpty from "lodash.isempty";
import { Loader } from "../../../Loader";
import { Button } from "../../../Button";
import { replaceEndOfLine } from "../../../../utils//text-extensions";
import { MapMarker } from "./Marker";
import { uniqueId } from "lodash";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";
import "swiper/modules/navigation/navigation.min.css";
import "./style.css";

import { Pagination, Navigation } from "swiper";
import { Attachment } from "../../../Attachment";

const ZeroCurrency = 0;

export class ProjectTaskCard extends Component {
  constructor(props) {
    super(props);

    this.map = null;
    this.state = {
      zoom: props.mapConfig.zoom,
      locationLatitude: props.mapConfig.latitude,
      locationLongitude: props.mapConfig.longitude,
      lightboxIsOpen: false,
      realizationLightboxIsOpen: false,
      currentImageIndex: 0,
      currentRealizationImageIndex: 0,
    };

    this.closeLightbox = this.closeLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
    this.gotoImage = this.gotoImage.bind(this);
    this.handleClickImage = this.handleClickImage.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
    this.zoomEnd = (e) => {
      let zoom = e.target.getZoom();
      this.setState({
        zoom: zoom,
      });
    };
  }

  componentDidMount() {
    // https://github.com/PaulLeCam/react-leaflet/issues/40
    setTimeout(() => {
      if (this.map && this.map.leafletElement) {
        this.map.leafletElement.invalidateSize(false);
      }
    }, 300);
  }

  componentDidUpdate(prevProps) {
    if (
      (this.props.locationLongitude !== prevProps.locationLongitude ||
        this.props.locationLatitude !== prevProps.locationLatitude) &&
      this.props.locationLatitude &&
      this.props.locationLongitude
    ) {
      this.setState({
        locationLongitude: this.props.locationLongitude,
        locationLatitude: this.props.locationLatitude,
      });
      setTimeout(() => {
        if (this.map && this.map.leafletElement) {
          this.map.leafletElement.invalidateSize(false);
        }
      }, 300);
    }

    if (
      this.props.mapConfig &&
      this.props.mapConfig.zoom !== this.state.zoom &&
      !prevProps.mapConfig
    ) {
      this.setState({
        zoom: this.props.mapConfig.zoom,
      });
    }
  }

  openLightbox(index, event, type) {
    const { currentImageIndex, currentRealizationImageIndex } = this.state;

    const isImages = type === "images";

    event.preventDefault();
    this.setState({
      lightboxIsOpen: isImages,
      realizationLightboxIsOpen: !isImages,
      currentImageIndex: isImages ? index : currentImageIndex,
      currentRealizationImageIndex: isImages
        ? currentRealizationImageIndex
        : index,
    });
  }

  closeLightbox = () => {
    this.setState({
      currentImageIndex: 0,
      realizationLightboxIsOpen: 0,
      lightboxIsOpen: false,
      realizationLightboxIsOpen: false,
    });
  };

  gotoPrevious(type) {
    const { currentImageIndex, currentRealizationImageIndex } = this.state;

    const isImages = type === "images";

    this.setState({
      currentImageIndex: isImages ? currentImageIndex - 1 : currentImageIndex,
      currentRealizationImageIndex: isImages
        ? currentRealizationImageIndex
        : currentRealizationImageIndex - 1,
    });
  }

  gotoNext(type) {
    const { currentImageIndex, currentRealizationImageIndex } = this.state;

    const isImages = type === "images";

    this.setState({
      currentImageIndex: isImages ? currentImageIndex + 1 : currentImageIndex,
      currentRealizationImageIndex: isImages
        ? currentRealizationImageIndex
        : currentRealizationImageIndex + 1,
    });
  }

  gotoImage(index, type) {
    const { currentImageIndex, currentRealizationImageIndex } = this.state;

    const isImages = type === "images";

    this.setState({
      currentImageIndex: isImages ? index : currentImageIndex,
      currentRealizationImageIndex: isImages
        ? currentRealizationImageIndex
        : index,
    });
  }

  handleClickImage(type) {
    const { images, realizationImages } = this.props;
    const { currentImageIndex, currentRealizationImageIndex } = this.state;

    const isImages = type === "images";

    if (isImages && currentImageIndex === images.length - 1) return;

    if (
      !isImages &&
      currentRealizationImageIndex === realizationImages.length - 1
    )
      return;

    this.gotoNext(type);
  }

  renderAttachmentsIcon(type) {
    switch (type) {
      case "application/pdf": {
        return (
          <i className="fas fa-file-pdf attachments-list__icon attachments-list__icon--primary-dark" />
        );
      }
      default: {
        return (
          <i className="fas fa-file attachments-list__icon attachments-list__icon--primary-dark" />
        );
      }
    }
  }
  render() {
    const {
      title,
      description,
      officeName,
      districtName,
      officeThematicAreaName,
      cost,
      statusName,
      images,
      documents,
      decision,
      budgetYearValue,
      locationDescription,
      isProjectTaskLoading,
      isOnlyOneOffice = false,
      showBackButton,
      markers,
      withLocation,
      realizationDescription,
      realizationImages,
    } = this.props;

    let galleryImages = map(images, (image) => ({
      className: "gallery__image",
      src: `/api/project-tasks/images/${image.id}`,
      alt: `Zdjęcie ${image.filename}`,
    }));

    let galleryRealizationImages = map(realizationImages, (image) => ({
      className: "gallery__image",
      src: `/api/project-tasks/images/${image.id}`,
      alt: `Zdjęcie ${image.filename}`,
    }));

    return (
      <Fragment>
        {isProjectTaskLoading ? (
          <Loader loading={isProjectTaskLoading} />
        ) : (
          <div id="content" className="container">
            <div className="project-task-single margin-bottom-20">
              <div
                className="project-task-single__header"
                style={{ flexDirection: "column" }}
              >
                <div className="project-task__text">
                  <div className="project-task__title">{title}</div>
                </div>

                <div
                  className="project-task__info"
                  style={{ marginBottom: 30 }}
                >
                  <div className="info__label">Opis:</div>
                  <div
                    className="info__value"
                    dangerouslySetInnerHTML={{
                      __html: replaceEndOfLine(description),
                    }}
                  ></div>
                </div>
                {!isOnlyOneOffice && (
                  <div className="project-task__info">
                    <div className="info__label">Jednostka:</div>
                    <div className="info__value">{officeName}</div>
                  </div>
                )}
                <div className="project-task__info">
                  <div className="info__label">Obszar:</div>
                  <div className="info__value">
                    {districtName ? districtName : "Miasto"}
                  </div>
                </div>
                <div className="project-task__info">
                  <div className="info__label">Kategoria:</div>
                  <div className="info__value">{officeThematicAreaName}</div>
                </div>
                <div className="project-task__info">
                  <div className="info__label">Szacowany koszt:</div>
                  <div className="info__value">
                    {cost
                      ? cost.toLocaleString("pl-PL", {
                          style: "currency",
                          currency: "PLN",
                        })
                      : ZeroCurrency.toLocaleString("pl-PL", {
                          style: "currency",
                          currency: "PLN",
                        })}
                  </div>
                </div>
                <div className="project-task__info">
                  <div className="info__label">Rok budżetowy:</div>
                  <div className="info__value">{budgetYearValue}</div>
                </div>
                <div className="project-task__info">
                  <div className="info__label">Status:</div>
                  <div className="info__value">{statusName}</div>
                </div>
              </div>
              <div className="project-task-single__content">
                <div className="project-task-single__map">
                  {locationDescription && (
                    <div style={{ marginBottom: 15 }}>
                      <div className="project-task__subtitle">Lokalizacja</div>
                      <div className="project-task__info">
                        <div className="info__label">Opis:</div>
                        <div className="info__value">{locationDescription}</div>
                      </div>
                    </div>
                  )}
                  {withLocation && (
                    <LeafletMap
                      ref={(ref) => {
                        this.map = ref;
                      }}
                      keyboard={false}
                      center={{
                        lat: !!markers.length
                          ? markers[0].latitude
                          : this.state.locationLatitude,
                        lng: !!markers.length
                          ? markers[0].longitude
                          : this.state.locationLongitude,
                      }}
                      zoom={this.state.zoom}
                      style={{ height: "360px", outline: "none" }}
                      onzoomend={this.zoomEnd}
                    >
                      <TileLayer
                        keyboard={false}
                        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      />
                      {(markers || []).map((marker) => (
                        <MapMarker
                          key={uniqueId()}
                          {...{ marker, draggable: false, withPopup: true }}
                        />
                      ))}
                    </LeafletMap>
                  )}
                </div>
              </div>
              {!!images && images.length ? (
                <Swiper
                  modules={[Pagination, Navigation]}
                  navigation={true}
                  pagination={{
                    type: "bullets",
                  }}
                >
                  {(images || []).map((image, i) => (
                    <SwiperSlide key={image.id}>
                      <a
                        key={image.id}
                        onClick={(e) => this.openLightbox(i, e, "images")}
                      >
                        <img
                          src={`data:image/png;base64,${image.thumbImage}`}
                          alt={`Zdjęcie ${image.fileName}`}
                        />
                      </a>
                    </SwiperSlide>
                  ))}
                  <Lightbox
                    images={galleryImages}
                    isOpen={this.state.lightboxIsOpen}
                    currentImage={this.state.currentImageIndex}
                    onClickImage={() => this.handleClickImage("images")}
                    onClickNext={() => this.gotoNext("images")}
                    onClickPrev={() => this.gotoPrevious("images")}
                    onClickThumbnail={() => this.gotoImage("images")}
                    onClose={this.closeLightbox}
                  />
                </Swiper>
              ) : null}
              {!isEmpty(documents) && (
                <div className="project-task-single__documents">
                  <div className="project-task__subtitle">Dokumenty</div>
                  <div className="attachments-list">
                    {map(documents, (attachment) => (
                      <Attachment
                        key={attachment.id}
                        {...{
                          attachment,
                          url: `api/project-tasks/documents/${attachment.id}`,
                        }}
                      >
                        {this.renderAttachmentsIcon(attachment.contentType)}
                      </Attachment>
                    ))}
                  </div>
                </div>
              )}
              {decision && decision.length && (
                <div className="project-task-single__footer">
                  <div className="project-task__subtitle">Decyzja</div>
                  <div className="project-task__description">
                    {decision || "Brak decyzji"}
                  </div>
                </div>
              )}
              {realizationDescription && realizationDescription.length && (
                <div className="project-task-single__footer">
                  <div className="project-task__subtitle">Realizacja</div>
                  <div className="project-task__description">
                    {realizationDescription || "Brak decyzji"}
                  </div>
                </div>
              )}
              {!!realizationImages && realizationImages.length ? (
                <Swiper
                  modules={[Pagination, Navigation]}
                  navigation={true}
                  pagination={{
                    type: "bullets",
                  }}
                >
                  {(realizationImages || []).map((image, i) => (
                    <SwiperSlide key={image.id}>
                      <a
                        key={image.id}
                        onClick={(e) =>
                          this.openLightbox(i, e, "realizationImages")
                        }
                      >
                        <img
                          src={`data:image/png;base64,${image.thumbImage}`}
                          alt={`Zdjęcie ${image.fileName}`}
                          height={240}
                        />
                      </a>
                    </SwiperSlide>
                  ))}
                  <Lightbox
                    images={galleryRealizationImages}
                    isOpen={this.state.realizationLightboxIsOpen}
                    currentImage={this.state.currentRealizationImageIndex}
                    onClickImage={() =>
                      this.handleClickImage("realizationImages")
                    }
                    onClickNext={() => this.gotoNext("realizationImages")}
                    onClickPrev={() => this.gotoPrevious("realizationImages")}
                    onClickThumbnail={() => this.gotoImage("realizationImages")}
                    onClose={() => this.closeLightbox()}
                  />
                </Swiper>
              ) : null}
              {showBackButton && (
                <div className="buttons margin-top-20">
                  <Button variant="danger" onClick={this.props.onCancel}>
                    Powrót
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}
